import { isValid } from 'date-fns';

const endsWithDateKeys = ['On', 'At', 'Date', 'Through', 'OnMin', 'OnMax', 'AtMin', 'AtMax', 'By', 'Time'];

export const dateTimeReviver = (key: any, value: any) => {
  if (typeof value === 'string') {
    if (endsWithDateKeys.some((k) => key.endsWith(k))) {
      const d = new Date(value);
      return isValid(d) ? d : value;
    }
  }
  return value;
};
